export default "__VITE_ASSET__CUC207z8__"